import(/* webpackMode: "eager", webpackExports: ["PricingTable"] */ "/vercel/path0/apps/web/src/app/(marketing)/pricing/_components/PricingTable.tsx");
